import React from "react";
import { Button, Card } from "react-bootstrap";
import "./ProjectCard.css";

function ProjectCard({data}) {
  return (
    <Card className="text-center">
      <Card.Img className="project-card-img" variant="top" src={data.image}/>
 
      <Card.Body>

        <Card.Title>{data.title}</Card.Title>

        <Card.Text>{data.data.description}</Card.Text>

        <Card.Title style={{marginTop: "5%", marginBottom: "3%"}}>Technologies Used:</Card.Title>

        <div style={{display: "flex", justifyContent: "space-evenly"}}>
            {Object.keys(data.data.tech).map((skill) => {
                return (
                        <div>
                            <img width="30" src={data.data.tech[skill]}></img>
                            <p>{skill}</p>
                        </div>
                )
            })}
        </div>

        <Card.Title style={{marginTop: "5%", marginBottom: "3%"}}>Features:</Card.Title>
        <ul style={{textAlign: "left"}}>
            {data.data.features.map((feature) => {
                return (
                    <li>
                       <p>{feature}</p> 
                    </li>
                )
            })}
        </ul>


        <a href={data.link} target="_blank" rel="noreferrer">
          <Button variant="primary" style={{marginTop: "3%"}}>Go to {data.title}</Button>
        </a>

      </Card.Body>

    </Card>
  );
}

export default ProjectCard;
